'use client';
import React from 'react';


interface VesselData {
  vessel: string;
  lsd: number;
  owner: string;
  scope: string;
}

interface Props {
  vessels: VesselData[];
}

const SCOPE_COLORS: Record<string, string> = {
  'Anglo American': 'bg-blue-50 text-blue-700',
  FMG: 'bg-purple-50 text-purple-700',
  'Rio Tinto': 'bg-red-50 text-red-700',
  Vale: 'bg-green-50 text-green-700',
};

export default function VesselRankingTable({ vessels }: Props) {
  const maxLsd = Math.max(...vessels.map((v) => v.lsd));

  return (
    <div className="space-y-2">
      {vessels.map((v, i) => (
        <div
          key={`rank-${v.vessel}`}
          className="flex items-center gap-3 py-2 border-b last:border-b-0"
          style={{ borderColor: 'hsl(var(--border))' }}
        >
          <span className="text-xs font-bold tabular-nums w-5 text-center flex-shrink-0"
            style={{ color: i < 3 ? 'hsl(var(--destructive))' : 'hsl(var(--muted-foreground))' }}>
            {i + 1}
          </span>
          <div className="flex-1 min-w-0">
            <p className="text-xs font-semibold truncate">{v.vessel}</p>
            <div className="flex items-center gap-1.5 mt-0.5">
              <span className="text-xs text-muted truncate">{v.owner}</span>
              <span className={`badge text-xs ${SCOPE_COLORS[v.scope] || 'bg-gray-100 text-gray-600'}`}>{v.scope}</span>
            </div>
          </div>
          <div className="flex items-center gap-2 flex-shrink-0">
            <div className="w-20 h-1.5 rounded-full bg-muted overflow-hidden hidden sm:block">
              <div
                className="h-full rounded-full"
                style={{
                  width: `${(v.lsd / maxLsd) * 100}%`,
                  background: v.lsd > 60 ? 'hsl(var(--destructive))' : v.lsd > 40 ? 'hsl(var(--warning))' : 'hsl(var(--success))',
                }}
              />
            </div>
            <span
              className="font-mono text-sm font-bold tabular-nums px-2 py-0.5 rounded-md"
              style={{
                background: v.lsd > 60 ? 'hsl(355 75% 58% / 0.12)' : v.lsd > 40 ? 'hsl(38 92% 50% / 0.12)' : 'hsl(145 60% 40% / 0.12)',
                color: v.lsd > 60 ? 'hsl(355 75% 38%)' : v.lsd > 40 ? 'hsl(38 72% 32%)' : 'hsl(145 60% 28%)',
              }}
            >
              {v.lsd}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}